import { newsList, type NewsItem } from '@/mocks/news';
import { videoList, type VideoItem } from '@/mocks/videos';
import { topicList, type TopicItem } from '@/mocks/topics';
import { specialList, type SpecialItem } from '@/mocks/specials';

export type ContentItem = NewsItem | VideoItem | TopicItem | SpecialItem;

export const newsItems: NewsItem[] = newsList;
export const videoItems: VideoItem[] = videoList;
export const topicItems: TopicItem[] = topicList;
export const specialItems: SpecialItem[] = specialList;

export const allItems: ContentItem[] = [...newsList, ...videoList, ...topicList, ...specialList];

export function getContentById(id: string): ContentItem | undefined {
  return allItems.find((item) => item.id === id);
}

export function getContentByType(type: ContentItem['type']): ContentItem[] {
  return allItems.filter((item) => item.type === type);
}

export function getRelated(item: ContentItem, limit = 4): ContentItem[] {
  if (item.type === 'special' && 'relatedIds' in item) {
    const picked = (item.relatedIds || [])
      .map((rid) => getContentById(rid))
      .filter((entry): entry is ContentItem => Boolean(entry));
    if (picked.length) return picked.slice(0, limit);
  }
  const pool = allItems.filter((entry) => entry.id !== item.id && entry.type !== 'special');
  const sameCategory = pool.filter((entry) => entry.tags.some((tag) => item.tags.includes(tag)));
  const others = pool.filter((entry) => !sameCategory.includes(entry));
  return [...sameCategory, ...others].slice(0, limit);
}

export function searchContent(keyword: string): ContentItem[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return allItems.filter((item) => {
    if (item.type === 'special') return false;
    return (
      item.title.toLowerCase().includes(q) ||
      item.summary.toLowerCase().includes(q) ||
      item.tags.some((tag) => tag.toLowerCase().includes(q))
    );
  });
}

export function getHotItems(limit = 4): ContentItem[] {
  return [...allItems]
    .filter((item) => item.type !== 'special')
    .sort((a, b) => b.views - a.views)
    .slice(0, limit);
}

export function formatViews(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return `${value}`;
}